// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hPMP","rootMobile":"styles_rootMobile__1sEsy"};